var React = require('react');

function No (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"1100","height":"800","fill":"#ef2b2d","key":0}),React.createElement("rect",{"width":"200","height":"800","x":"300","fill":"#fff","key":1}),React.createElement("rect",{"width":"1100","height":"200","y":"300","fill":"#fff","key":2}),React.createElement("rect",{"width":"100","height":"800","x":"350","fill":"#002868","key":3}),React.createElement("rect",{"width":"1100","height":"100","y":"350","fill":"#002868","key":4})]);
}

No.defaultProps = {"viewBox":"0 0 1100 800"};

module.exports = No;

No.default = No;
